export default __webpack_public_path__ + "static/Idea@992_2x-0358228652c71125f3a137556cd253f6.webp";